/**
 * Ensure a URL string has a protocol so <a href> opens externally instead of
 * being treated as a relative path (e.g. "www.coles.com.au" →
 * "https://www.coles.com.au"). Preserves already-valid URLs and tel:/mailto:.
 */
export function ensureUrl(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (!s) return "";
  if (/^[a-z][a-z0-9+.-]*:/i.test(s)) return s; // has a scheme already
  return `https://${s}`;
}
